export default {
  terms_and_conditions: {
    title: 'Registrierung bei wîse up abschließen',
    submit_button: 'Registrierung abschließen',
    terms_text: 'Allgemeine Geschäftsbedingungen',
  },
  invitations: {
    header: {
      title: 'Sie haben eine Einladung zu folgender Organisation erhalten',
    },
    role: 'Ihre Rolle',
    buttons: {
      accept: 'Akzeptieren',
      decline: 'Ablehnen',
    },
  },
  wkis_warning_banner: {
    warning:
      'Um zu verhindern, dass Ihr Konto vorübergehend gesperrt wird, melden Sie sich bitte mit einem aktiven WKIS-Konto an.',
    error:
      'Ihr Konto wurde vorübergehend gesperrt. Bitte melden Sie sich mit einem aktiven WKIS-Konto an.',
    sign_in_with_wkis: 'Anmelden mit WKIS-Konto',
  },
  wkis_warning_popup: {
    title:
      'Gemäß den aktualisierten AGB müssen sich alle Benutzer mit einem aktiven WKIS-Konto anmelden.',
    text: 'Wenn Ihr Konto nach fünf Benachrichtigungen nicht mit WKIS verknüpft ist, wird es gemäß den aktualisierten <a href="/">AGB</a> vorübergehend gesperrt.',
    attempts_left: 'attempts left',
    close_btn: 'Vorerst überspringen',
  },

  license_error: {
    title: 'Ihre Organisation hat nicht genügend Lizenzen',
    text: 'Bitte kontaktieren Sie den Eigentümer der Organisation für weitere Details.',
    back_btn: 'Zurück zur Anmeldeseite',
  },
}
